import styled from 'styled-components'

export const FirstLine = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
`

export const RightButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  button {
    width: auto;
  }
`

export const AttachmentButton = styled.div`
  background: #cdcdcd36;
  border-radius: ${({ theme }) => theme.border.radius.medium};
  color: #5d86da;

  width: 170px;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 8px;
  cursor: pointer;
`
